export default {
  create: {
    success: 'Revue de presse créée avec succès',
    error: 'Impossible de créer la revue de presse'
  },
  update: {
    success: 'Modification de la revue de presse effectué avec succès',
    error: 'Impossible de modifier la revue de presse'
  },
  delete: {
    error: 'Impossible de supprimer la revue de presse'
  }
}
